import { motion } from "framer-motion";
import { Tabs, Timeline, Typography } from "antd";
import { useState } from "react";
import {
  DollarOutlined,
  FileProtectOutlined,
  BarChartOutlined,
  TeamOutlined,
  MoneyCollectOutlined
} from "@ant-design/icons";

import LateComersTracker from "../../components/HrDashboard/LateComers";
import TotalEmployees from "../../components/HrDashboard/TotalEmployees";
import TotalLeaves from "../../components/HrDashboard/TotalLeaves";
import AttendanceReport from "../../components/HrDashboard/AttendanceReport";
import LeaveUtilization from "../../components/HrDashboard/LeaveUtilization";
import OrganisationLeave from "../../components/HrDashboard/OrganisationLeave";
import GenderSummary from "../../components/HrDashboard/GenderSummary";
import PayrollSummary from "../../components/HrDashboard/PayrollSummary";
import DepartmentWiseSalary from "../../components/HrDashboard/DepartmentWiseSalary";
import StatutoryCompliance from "../../components/HrDashboard/StatutoryCompliance";
import HrAnalytics from "../../components/HrDashboard/HrAnalytics";
import EmployeeAttendance from "../../components/HrDashboard/EmployeeAttendance";
import OtChart from "../../components/HrDashboard/OtChart";
import LopChart from "../../components/HrDashboard/LopChart";
import OrgChartList from "./OrgChartList";

const { Title } = Typography;

export default function HrIndex() {
  const [activeKey, setActiveKey] = useState("1");

  const cardVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const tabItems = [
    {
      key: "1",
      label: "Attendance & Leave",
      icon: <TeamOutlined />,
      content: (
        <>


          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <LopChart />
            </div>

          </div>
          <hr className="my-5" />

          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <EmployeeAttendance />
            </div>

          </div>
          <hr className="my-5" />

          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <OtChart />
            </div>

          </div>
          <hr className="my-5" />


          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <AttendanceReport />
            </div>

            <div style={{ flex: 1, minWidth: "420px" }}>
              <LeaveUtilization />
            </div>
          </div>
          <hr className="my-5" />
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <OrganisationLeave />
            </div>

            <div style={{ flex: 1, minWidth: "420px" }}>
              <GenderSummary />
            </div>
          </div>

          <hr className="my-5" />
          {/* <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <EmployeeAttendance />
            </div>

          </div> */}
        </>

      ),
    },
    {
      key: "2",
      label: "Payroll",
      icon: <MoneyCollectOutlined />,
      content: (
        <>
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              <PayrollSummary />
            </div>

            <div style={{ flex: 1, minWidth: "420px" }}>
              <DepartmentWiseSalary />
            </div>
          </div>
          <hr className="my-5" />
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "flex-start",
              justifyContent: "space-between",
              flexWrap: "wrap", // allows stacking on smaller screens
            }}
          >
            <div style={{ flex: 1, minWidth: "420px" }}>
              {/* <OrganisationLeave /> */}
            </div>

            <div style={{ flex: 1, minWidth: "420px" }}>
              {/* <GenderSummary /> */}
            </div>
          </div>
        </>

      ),
    },
    {
      key: "3",
      label: "Statutory Compliance",
      icon: <FileProtectOutlined />,
      content: (
        <div style={{ padding: "30px" }}>
          <Title level={4}>Statutory Compliance</Title>
          <StatutoryCompliance />
        </div>
      ),
    },
    {
      key: "4",
      label: "Analytics",
      icon: <BarChartOutlined />,
      content: (
        <div style={{ padding: "30px" }}>
          <HrAnalytics />
        </div>
      ),
    },
    {
      key: "5",
      label: "Org Charts",
      icon: <BarChartOutlined />,
      content: (
        <div style={{ padding: "30px" }}>
          <OrgChartList />
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        padding: "10px 50px",
        background: "#ffffffff",
        minHeight: "100vh",
      }}
    >

      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        type="card"
        items={tabItems.map((item) => ({
          key: item.key,
          label: (
            <span>
              {item.icon} {item.label}
            </span>
          ),
          children: item.content,
        }))}
      />
    </div>
  );
}
